import { AgGridReact } from "ag-grid-react";
import {
  defaultColDef,
  getRowId,
  newsColumns,
  newsThemeColumn,
} from "../../utils/gridHelper";
import { useCallback, useEffect, useMemo, useState } from "react";

import GridToolBar from "../GridToolBar";
import {
  deleteNews,
  deleteNewsTheme,
  getNewsTheme,
} from "../../utils/API/newsMethods";

import { useStore } from "../../hooks/store";
import NewsThemeForm from "../Form/NewsThemeForm";

export default function NewsThemeGrid() {
  const store = useStore();
  const [gridData, setGridData] = useState([]);
  const [gridApi, setGridApi] = useState(null);
  const [quickFilterText, setQuickFilterText] = useState("");
  const [NewsThemeData, setNewsData] = useState(undefined);

  const fetchNewsThemeData = () => {
    getNewsTheme().then(({ data }) => {
      setGridData(data);
    });
  };

  const handleAddOpener = () => {
    store.setForm(<NewsThemeForm />, fetchNewsThemeData);
  };

  const handleRedactOpener = () => {
    store.setForm(<NewsThemeForm />, fetchNewsThemeData, NewsThemeData);
  };

  const handleDelete = async () => {
    const { id } = NewsThemeData;
    const deletedNews = await deleteNewsTheme(id);
    if (deletedNews.status !== 200) {
      store.setAlert(deletedNews.data, "error");
      return;
    }
    fetchNewsThemeData();
  };

  const onGridReady = useCallback((e) => {
    // сохраняем АПИ
    setGridApi(e.api);
    fetchNewsThemeData();
  }, []);

  //Отслеживаем изменение текста для фильтра, устанавливаем соответстствующий фильтр в грид
  useEffect(() => {
    gridApi?.setGridOption("quickFilterText", quickFilterText);
  }, [quickFilterText, gridApi]);

  //выбор конрентной строки
  const rowSelection = useMemo(() => {
    return {
      mode: "singleRow",
      checkboxes: true,
      enableClickSelection: true,
    };
  }, []);

  const rowClickHandler = (e) => {
    e.data && setNewsData(e.data);
  };

  return (
    <div style={{ maxWidth: "100%", height: "100%" }}>
      <GridToolBar
        filter={true}
        onAdd={handleAddOpener}
        onRefresh={fetchNewsThemeData}
        onDelete={handleDelete}
        onUpdate={handleRedactOpener}
        filterValue={quickFilterText}
        filterOnChange={setQuickFilterText}
        dataToAction={NewsThemeData}
      />
      <AgGridReact
        onGridReady={onGridReady}
        onRowClicked={rowClickHandler}
        gerRowId={getRowId}
        rowData={gridData}
        defaultColDef={defaultColDef}
        tooltipShowDelay={500}
        rowSelection={rowSelection}
        columnDefs={[...newsThemeColumn]}
      />
    </div>
  );
}
